import React from 'react';
import { Stack } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { DIVIDER_LAYOUT_TYPES } from '../DividerPumoModule';
import { RecommendationsModule, ALGORITHMS } from '../RecommendationsPumoModule';
import { LazyLoad } from '../LazyLoad';
import { RecommendationsVariantFragment } from '../../generated/types';
import { StyliticsWidget } from '../StyliticsWidget';
import { LookRecommendations } from './LookRecommendations';

interface Props {
  variant: RecommendationsVariantFragment;
}

export const ProductRecommendations: React.FC<Props> = ({ variant }) => {
  const category = variant.category[0]?.replace(/[_\s]/g, '-').toLowerCase();

  const showStyliticsHotspots = useFeatureFlag('show-stylitics-hotspots', [
    { default: false },
    { if: true, then: true }
  ]);

  return (
    <LazyLoad>
      <Stack space={6}>
        <LookRecommendations />

        {showStyliticsHotspots && <StyliticsWidget variantId={variant.id} />}

        <RecommendationsModule
          algorithm={ALGORITHMS.SIMILAR_PRODUCTS}
          variant={variant}
          identifier={variant.id}
          divider={{
            layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
            text: 'You May Also Like'
          }}
        />

        {category === 'fine-jewelry' && (
          <RecommendationsModule
            algorithm={ALGORITHMS.FROM_THIS_DESIGNER}
            variant={variant}
            identifier={variant.id}
            divider={{
              layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
              text: 'From This Designer'
            }}
          />
        )}

        <RecommendationsModule
          algorithm={ALGORITHMS.RECENTLY_VIEWED}
          variant={variant}
          identifier={variant.id}
          divider={{
            layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
            text: 'Recently Viewed'
          }}
        />
      </Stack>
    </LazyLoad>
  );
};
